import isNil from 'lodash/isNil'
import type { ModelRate } from '@ztechapps/common.contract'
import { applyMarkupPct } from './applyMarkupPct'

export type EffectiveRates = {
  input: number
  output: number
}

/**
 * Display-only marked-up price for both the input and output per-million rate, using the
 * shared `applyMarkupPct` multiplier (`libs/ai/common/src/applyMarkupPct.ts`) also used by
 * `computeAiCost`, which owns the actual billed charge. Returns `undefined` when `markupPct`
 * is unset — no fallback to `CurrencyRate.markupPct` or any other value is invented.
 * Plain function, not a hook — none of the four hook-warranting conditions apply.
 */
export const getEffectiveRates = ({
  inputUsdPerMillion,
  outputUsdPerMillion,
  markupPct,
}: Pick<ModelRate, 'inputUsdPerMillion' | 'outputUsdPerMillion' | 'markupPct'>): EffectiveRates | undefined => {
  if (isNil(markupPct)) return undefined

  return {
    input: applyMarkupPct(inputUsdPerMillion, markupPct),
    output: applyMarkupPct(outputUsdPerMillion, markupPct),
  }
}
